"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useIconProps = require("../useIconProps");

var Error = function Error(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 16 16"
  }, (0, _useIconProps.useIconProps)(props)), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 6.504a.5.5 0 01.5.5v2.5a.5.5 0 01-1 0v-2.5a.5.5 0 01.5-.5zm.5 4.75a.5.5 0 11-1 0 .5.5 0 011 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.587 3.249a.5.5 0 01.865 0l5.518 9.504a.5.5 0 01-.432.751H2.5a.5.5 0 01-.433-.75l5.519-9.505zm-4.218 9.255l4.65-8.008 4.65 8.008h-9.3z"
  }));
};

Error.displayName = 'Error';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Error.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

var _default = Error;
exports.default = _default;